// extracted by mini-css-extract-plugin
export var border = "_t-7";
export var brand = "_t-r";
export var button = "_t-j";
export var center = "_t-9";
export var centered = "_t-5";
export var closeButton = "_t-b";
export var disabledWrapper = "_t-k";
export var error = "_t-n";
export var extraLarge = "_t-4";
export var extraSmall = "_t-1";
export var fill = "_t-g";
export var footer = "_t-f";
export var footerAction = "_t-h";
export var footerButtons = "_t-i";
export var header = "_t-6";
export var icon = "_t-m";
export var info = "_t-q";
export var inline = "_t-8";
export var large = "_t-3";
export var main = "_t-c";
export var modal = "_t-0";
export var neutral = "_t-s";
export var noPadding = "_t-e";
export var none = "_t-t";
export var scrollable = "_t-d";
export var small = "_t-2";
export var success = "_t-p";
export var tight = "_t-l";
export var titleIcon = "_t-a";
export var warn = "_t-o";